import { InfoCircleOutlined, Tooltip } from 'gokwik-ui-kit'

const DocumentAnalysisData = ({ response, document }) => {
    const interpretResponse = (response) => {
        const { doc_type, validity_score, document_number, date_of_birth, year_of_birth, visibility, name, address } =
            response

        let prominentReason = ''
        let emoji

        if (validity_score === 'Low') {
            emoji = '❌'
            if (doc_type === 'Not Aadhaar' || doc_type === 'Not PAN' || doc_type === 'Not BR') {
                prominentReason = `The document uploaded is ${doc_type}`
            } else if (!document_number) {
                prominentReason = 'The document number could not be extracted.'
            } else if (visibility === 'Unclear') {
                prominentReason = 'The image visibility is unclear.'
            } else if (!name) {
                prominentReason = 'The name could not be extracted.'
            } else if (!date_of_birth && !year_of_birth) {
                prominentReason = 'The date of birth could not be extracted.'
            } else if (doc_type === 'Aadhaar Back' && !address) {
                prominentReason = 'The address could not be extracted.'
            } else {
                prominentReason = 'Multiple attributes could not be extracted, leading to a low confidence score.'
            }
        } else {
            emoji = '✅'
        }

        if (doc_type && validity_score) {
            return {
                validity_score,
                prominentReason,
                emoji,
            }
        }
    }

    if (!response) return null

    const AIResponse = interpretResponse(response)

    const excludedFields = ['doc_type', 'validity_score']
    const labelMap = {
        doc_type: 'Document Type',
        validity_score: 'Validity Score',
        document_number: 'Document Number',
        date_of_birth: 'Date of Birth',
        year_of_birth: 'Year of Birth',
        visibility: 'Visibility',
        name: 'Name',
        address: 'Address',
        CIN: 'CIN',
        DIN: 'DIN',
        PAN: 'PAN',
        signatures: 'Signatures',
        seal_stamp: 'Stamp',
    }

    const renderTooltipContent = () => {
        return (
            <div>
                {Object.entries(response).map(([key, value]) => {
                    if (value && typeof value === 'string' && value.trim() === '') return null // skip empty strings
                    const formattedKey =
                        labelMap[key] || key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())
                    return (
                        <p key={key}>
                            <strong>{formattedKey}:</strong> {String(value ?? 'N/A')}
                        </p>
                    )
                })}
            </div>
        )
    }

    return (
        <div className='p-2'>
            <div className='flex gap-2'>
                <div className='flex flex-col gap-1'>
                    <div className='flex gap-1'>
                        <strong>Likelihood of Acceptance:</strong> {AIResponse?.validity_score} {AIResponse?.emoji}
                        <Tooltip title={renderTooltipContent()}>
                            <InfoCircleOutlined className='cursor-pointer text-orange-400' />
                        </Tooltip>
                    </div>
                    {AIResponse?.validity_score === 'Low' && <p>{AIResponse?.prominentReason}</p>}
                </div>
            </div>
        </div>
    )
}

export default DocumentAnalysisData
